import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { format } from "date-fns";
import { LangContext } from "../LangContext.jsx";
class DocumentFileItem extends Component {
  static contextType = LangContext;

  render() {
    const { file } = this.props;
    return (
      <tr>
        <td>
          <img
            src={"/assets/img/" + window.getMimeSVG(file.extension != undefined && file.extension.length > 0 ? file.extension : file.path)}
            alt={file.title || 'file'}
          />
        </td>

        <td>{file.title}</td>
        <td>{file.fiscal_name}</td>
        <td>{file.status}</td>
        <td>{format(new Date(file.updated_at), 'dd/MM/yyyy')}</td>

        <td className="text-right">
          <a
            href={"/files/" + file.person_document_id}
            target="_blank"
            download
            className="btn btn-icon btn-light btn-xs mr-5"
          >
            <i className="flaticon2-download text-primary"></i>
          </a>

          <a
            href={"/clients/dossiers/" + file.invitation_id + "/history_file/" + file.person_document_id}
            className="btn btn-xs btn-icon btn-light-secondary"
          >
            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
          </a>
        </td>
      </tr>
    );
  }
}

export default DocumentFileItem;

if (document.getElementById('DocumentFileItem')) {
    ReactDOM.render(<DocumentFileItem />, document.getElementById('DocumentFileItem'));
}